import { fontOptions } from "@kit/design/font-select"

export function createFontImportUrl(fonts) {
  const importableFonts = fonts
    .map(font => {
      const option = fontOptions.find(option => option.label === font)
      if (option?.noImport) return false
      return option
    })
    .filter(Boolean)

  if (!importableFonts.length) return

  const params = importableFonts
    .map(font => {
      const label = font.label.replaceAll(" ", "+")
      return label + ":" + font.supportedWeights
    })
    .join("|")

  return `https://fonts.googleapis.com/css?family=${params}&display=swap`
}
